import { ISelectCompProps } from "@fl/shared/src/types/select";
import React from "react";
import Select from "react-select";

const SelectComp: React.FC<ISelectCompProps> = ({
  options,
  label,
  ...rest
}) => {
  return (
    <div>
      {label && <label className="select-label">{label}</label>}
      <Select
        placeholder="Selecione..."
        noOptionsMessage={() => "Sem Opções"}
        options={options} // Passamos as opções como esperado
        {...rest} // Repasse de todas as propriedades restantes para o react-select
      />
    </div>
  );
};

export default SelectComp;
